/**
 * FAM Cookie Manager
 * Handles GDPR compliant cookie consent and script/iframe blocking.
 */ const $5a4ef64b89c7976a$var$CONSENT_KEY = 'fam_cookie_consent';
const $5a4ef64b89c7976a$export$c0f66b9778462a6f = {
    init () {
        this.checkConsent();
        this.bindEvents();
    },
    getConsentData () {
        const data = localStorage.getItem($5a4ef64b89c7976a$var$CONSENT_KEY);
        if (!data) return null;
        try {
            const parsed = JSON.parse(data);
            // Soporte retrocompatible para el formato booleano anterior
            if (typeof parsed.accepted === 'boolean') return {
                necessary: true,
                marketing: parsed.accepted
            };
            return parsed;
        } catch (e) {
            return null;
        }
    },
    checkConsent () {
        const consent = this.getConsentData();
        if (!consent) {
            this.showBanner();
            this.blockElements();
        } else if (consent.marketing) this.loadElements();
        else this.blockElements();
    },
    showBanner () {
        // Inject banner if not exists
        if (!document.getElementById('fam-cookie-banner')) {
            const bannerHTML = `
        <div id="fam-cookie-banner" class="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6 transition-transform duration-700 translate-y-full">
          <div class="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl border border-white/20 shadow-2xl p-6 md:p-8 rounded-2xl flex flex-col md:flex-row items-center gap-6">
            <div class="flex-1">
              <h3 class="font-heading text-xl font-bold text-tinta mb-2 flex items-center gap-2">
                <span class="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
                Tu privacidad nos importa
              </h3>
              <p class="text-sm text-tinta/70 leading-relaxed">
                Utilizamos cookies propias y de terceros para mejorar tu experiencia, analizar el tr\xe1fico y mostrarte contenido personalizado. Puedes aceptarlas todas o configurar tus preferencias.
                <a href="politica-cookies.html" class="text-accent underline font-bold ml-1">Saber m\xe1s</a>.
              </p>
            </div>
            <div class="flex flex-wrap gap-3 shrink-0">
              <button id="cookie-reject" class="px-6 py-3 border-2 border-tinta/10 text-tinta font-bold text-xs uppercase tracking-widest hover:bg-tinta hover:text-white transition-all rounded-lg">
                Rechazar
              </button>
              <button id="cookie-configure" class="px-6 py-3 border-2 border-accent/20 text-accent font-bold text-xs uppercase tracking-widest hover:bg-accent/10 transition-all rounded-lg">
                Configurar
              </button>
              <button id="cookie-accept" class="px-8 py-3 bg-accent text-white font-bold text-xs uppercase tracking-widest hover:bg-primary transition-all shadow-lg shadow-accent/20 rounded-lg">
                Aceptar todas
              </button>
            </div>
          </div>
        </div>
      `;
            document.body.insertAdjacentHTML('beforeend', bannerHTML);
            setTimeout(()=>{
                const banner = document.getElementById('fam-cookie-banner');
                if (banner) banner.classList.remove('translate-y-full');
            }, 100);
        }
    },
    hideBanner () {
        const banner = document.getElementById('fam-cookie-banner');
        if (banner) {
            banner.classList.add('translate-y-full');
            setTimeout(()=>banner.remove(), 700);
        }
    },
    showConfigModal () {
        if (document.getElementById('fam-cookie-modal')) {
            document.getElementById('fam-cookie-modal').classList.remove('hidden');
            return;
        }
        const consent = this.getConsentData();
        const marketingChecked = consent ? consent.marketing : false;
        const modalHTML = `
      <div id="fam-cookie-modal" class="fixed inset-0 z-[10000] flex items-center justify-center p-4">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-tinta/40 backdrop-blur-sm transition-opacity" id="cookie-modal-backdrop"></div>
        
        <!-- Modal Content -->
        <div class="relative bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">
          <div class="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
            <h3 class="font-heading text-xl font-bold text-tinta">Configuraci\xf3n de Cookies</h3>
            <button id="cookie-modal-close" class="text-gray-400 hover:text-accent transition p-1">
              <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
          </div>
          
          <div class="p-6 overflow-y-auto flex-1 space-y-6">
            <p class="text-sm text-gray-600 leading-relaxed">
              Cuando visitas nuestro sitio web, podemos almacenar informaci\xf3n en tu navegador mediante el uso de cookies. Esta informaci\xf3n se usa para que el sitio funcione correctamente y para fines anal\xedticos y de rendimiento. Puedes elegir qu\xe9 categor\xedas de cookies permitir.
            </p>
            
            <div class="space-y-4">
              <!-- Necesarias -->
              <div class="flex flex-col sm:flex-row items-start justify-between gap-4 p-5 rounded-xl bg-gray-50 border border-gray-200">
                <div class="flex-1">
                  <h4 class="font-bold text-tinta mb-1 text-base">Cookies Estrictamente Necesarias / T\xe9cnicas</h4>
                  <p class="text-sm text-gray-600">Estas cookies son esenciales para que el sitio web funcione con normalidad, garantizando opciones de seguridad, protecci\xf3n contra spam (reCAPTCHA) y prevenci\xf3n de fraude. No se pueden desactivar.</p>
                </div>
                <div class="shrink-0 flex items-center mt-1 sm:mt-0">
                  <span class="px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs font-bold uppercase tracking-widest">Siempre Activo</span>
                </div>
              </div>
              
              <!-- Publicitarias -->
              <div class="flex flex-col sm:flex-row items-start justify-between gap-4 p-5 rounded-xl border border-gray-200 hover:border-accent/30 transition-colors">
                <div class="flex-1">
                  <h4 class="font-bold text-tinta mb-1 text-base">Cookies de Terceros y Publicidad</h4>
                  <p class="text-sm text-gray-600">Nos permiten cargar contenidos externos (como mapas interactivos) y recopilar informaci\xf3n sobre c\xf3mo usas el sitio web para mejorar tu experiencia (estad\xedsticas, preferencias).</p>
                </div>
                <div class="shrink-0 mt-1 sm:mt-0 flex items-center">
                  <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" id="toggle-marketing" class="sr-only peer" ${marketingChecked ? 'checked' : ''}>
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-6 border-t border-gray-100 flex flex-wrap gap-3 justify-end bg-gray-50">
            <button id="cookie-reject-all-modal" class="px-6 py-3 border-2 border-tinta/10 text-tinta font-bold text-xs uppercase tracking-widest hover:bg-tinta hover:text-white transition-all rounded-lg">
              Rechazar Todas
            </button>
            <button id="cookie-save-preferences" class="px-6 py-3 bg-accent text-white font-bold text-xs uppercase tracking-widest hover:bg-primary transition-all shadow-lg rounded-lg">
              Guardar Preferencias
            </button>
          </div>
        </div>
      </div>
    `;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        const closeModal = ()=>{
            const modal = document.getElementById('fam-cookie-modal');
            if (modal) modal.classList.add('hidden');
        };
        document.getElementById('cookie-modal-close').addEventListener('click', closeModal);
        document.getElementById('cookie-modal-backdrop').addEventListener('click', closeModal);
        document.getElementById('cookie-reject-all-modal').addEventListener('click', ()=>{
            this.setConsent({
                necessary: true,
                marketing: false
            });
            closeModal();
        });
        document.getElementById('cookie-save-preferences').addEventListener('click', ()=>{
            const isMarketingAccepted = document.getElementById('toggle-marketing').checked;
            this.setConsent({
                necessary: true,
                marketing: isMarketingAccepted
            });
            closeModal();
        });
    },
    bindEvents () {
        document.addEventListener('click', (e)=>{
            // Banner buttons
            if (e.target.closest('#cookie-accept')) this.setConsent({
                necessary: true,
                marketing: true
            });
            if (e.target.closest('#cookie-reject')) this.setConsent({
                necessary: true,
                marketing: false
            });
            if (e.target.closest('#cookie-configure')) this.showConfigModal();
            // Re-open from policy page or footer
            if (e.target.closest('.pdcc-open-modal') || e.target.closest('.js-open-cookies')) {
                e.preventDefault();
                // Abrir directamente el modal de configuración para mejor experiencia de usuario
                this.showConfigModal();
            }
        });
    },
    setConsent (preferences) {
        const data = {
            ...preferences,
            timestamp: new Date().getTime()
        };
        localStorage.setItem($5a4ef64b89c7976a$var$CONSENT_KEY, JSON.stringify(data));
        this.hideBanner();
        if (data.marketing) this.loadElements();
        else this.blockElements();
    },
    blockElements () {
        // Block Google Maps Iframe
        const maps = document.querySelectorAll('iframe[src*="google.com/maps"]');
        maps.forEach((iframe)=>{
            if (!iframe.dataset.src) {
                iframe.dataset.src = iframe.src;
                iframe.src = 'about:blank';
                // Add a placeholder message
                const wrapper = iframe.parentElement;
                if (wrapper && !wrapper.querySelector('.cookie-placeholder')) {
                    const placeholder = document.createElement('div');
                    placeholder.className = 'cookie-placeholder absolute inset-0 bg-gray-100 flex flex-col items-center justify-center p-6 text-center z-10';
                    placeholder.innerHTML = `
            <svg class="w-10 h-10 text-tinta/20 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 7m0 10V7" />
            </svg>
            <p class="text-sm text-tinta/60 mb-4">Para ver este mapa interactivo debes aceptar las cookies de marketing.</p>
            <button class="js-open-cookies bg-primary text-white px-4 py-2 text-xs font-bold uppercase tracking-widest hover:bg-accent transition shadow-lg">Configurar Cookies</button>
          `;
                    wrapper.style.position = 'relative';
                    wrapper.appendChild(placeholder);
                }
            }
        });
    // Block Analytics if needed
    },
    loadElements () {
        // Restore Google Maps
        const maps = document.querySelectorAll('iframe[data-src]');
        maps.forEach((iframe)=>{
            iframe.src = iframe.dataset.src;
            const placeholder = iframe.parentElement.querySelector('.cookie-placeholder');
            if (placeholder) placeholder.remove();
        });
        // Load dynamic scripts (Analytics)
        this.injectAnalytics();
    },
    injectAnalytics () {
        // GA ID placeholder
        if (!window.ga_injected) {
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX';
            document.head.appendChild(script);
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-XXXXXXXXXX');
            window.ga_injected = true;
        }
    }
};


// src/js/icons.js
const $2880fb3dc6eeb637$export$fde44257752a9f60 = {
    // Personas / Social
    family: `<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>`,
    users: `<path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>`,
    user: `<path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>`,
    child: `<path stroke-linecap="round" stroke-linejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>`,
    // Añadidos de otras páginas
    'user-circle': `<circle cx="12" cy="7" r="3" /><path stroke-linecap="round" stroke-linejoin="round" d="M5 20c0-4 3.5-6 7-6s7 2 7 6" />`,
    'users-two': `<circle cx="9" cy="7" r="3" /><circle cx="17" cy="7" r="3" /><path stroke-linecap="round" stroke-linejoin="round" d="M2 20c0-4 3-6 7-6s7 2 7 6" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 14c2.5 0 5 1.5 5 6" />`,
    'users-three': `<circle cx="12" cy="8" r="2.5" /><circle cx="6.5" cy="10" r="2" /><circle cx="17.5" cy="10" r="2" /><path stroke-linecap="round" stroke-linejoin="round" d="M7 20c0-3.2 2.4-5 5-5s5 1.8 5 5" /><path stroke-linecap="round" stroke-linejoin="round" d="M2.5 20c0-2.6 2-4 4-4" /><path stroke-linecap="round" stroke-linejoin="round" d="M21.5 20c0-2.6-2-4-4-4" />`,
    // Salud / Bienestar
    equality: `<path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>`,
    'heart-outline': `<path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>`,
    heart: `<path stroke-linecap="round" stroke-linejoin="round" d="M12 20s-7-4.6-7-9.4C5 7.3 6.9 5.5 9.3 5.5c1.6 0 2.8.8 3.2 1.4.4-.6 1.6-1.4 3.2-1.4 2.4 0 4.3 1.8 4.3 5.1C19 15.4 12 20 12 20z" />`,
    health: `<path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>`,
    // Voluntariado / Trabajo
    volunteering: `<path stroke-linecap="round" stroke-linejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>`,
    hand: `<path stroke-linecap="round" stroke-linejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"/>`,
    'hand-open': `<path stroke-linecap="round" stroke-linejoin="round" d="M7 11V7a1.5 1.5 0 0 1 3 0v4" /><path stroke-linecap="round" stroke-linejoin="round" d="M10 11V6a1.5 1.5 0 0 1 3 0v5" /><path stroke-linecap="round" stroke-linejoin="round" d="M13 11V7a1.5 1.5 0 0 1 3 0v6" /><path stroke-linecap="round" stroke-linejoin="round" d="M16 13V9a1.5 1.5 0 0 1 3 0v5" /><path stroke-linecap="round" stroke-linejoin="round" d="M7 11c0 5 2.5 8 5 8s5-3 5-6" />`,
    briefcase: `<rect x="3" y="7" width="18" height="13" rx="2" /><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V5a4 4 0 0 1 8 0v2" />`,
    // Tecnología / Innovación
    innovation: `<path stroke-linecap="round" stroke-linejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>`,
    computer: `<path stroke-linecap="round" stroke-linejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>`,
    chip: `<path stroke-linecap="round" stroke-linejoin="round" d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/>`,
    lightbulb: `<path stroke-linecap="round" stroke-linejoin="round" d="M9 18h6" /><path stroke-linecap="round" stroke-linejoin="round" d="M10 22h4" /><path stroke-linecap="round" stroke-linejoin="round" d="M12 2a7 7 0 0 0-4 12c.6.5 1 1.3 1 2v1h6v-1c0-.7.4-1.5 1-2a7 7 0 0 0-4-12z" />`,
    // Educación / Formación
    education: `<path stroke-linecap="round" stroke-linejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 01-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"/>`,
    'book-open': `<path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />`,
    book: `<rect x="5" y="4" width="14" height="16" rx="2" /><path stroke-linecap="round" stroke-linejoin="round" d="M10 4v16" />`,
    certificate: `<path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>`,
    // Medioambiente / Sostenibilidad
    sustainability: `<path stroke-linecap="round" stroke-linejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>`,
    leaf: `<path stroke-linecap="round" stroke-linejoin="round" d="M20 4s-6.5 0-10 3.5S6 18 6 18s6.5 0 10-3.5S20 4 20 4z" /><path stroke-linecap="round" stroke-linejoin="round" d="M8 16c2-2 6-6 10-8" />`,
    'leaf-sprout': `<path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>`,
    globe: `<path stroke-linecap="round" stroke-linejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>`,
    flower: `<circle cx="12" cy="5" r="2" /><circle cx="12" cy="19" r="2" /><circle cx="5" cy="12" r="2" /><circle cx="19" cy="12" r="2" /><circle cx="7.5" cy="7.5" r="2" /><circle cx="16.5" cy="7.5" r="2" /><circle cx="7.5" cy="16.5" r="2" /><circle cx="16.5" cy="16.5" r="2" /><circle cx="12" cy="12" r="2.5" />`,
    // General / Misc
    smile: `<path stroke-linecap="round" stroke-linejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`,
    star: `<path stroke-linecap="round" stroke-linejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>`,
    'badge-check': `<circle cx="12" cy="12" r="8" /><path stroke-linecap="round" stroke-linejoin="round" d="M8.5 12.5l2.5 2.5 4.5-5" />`,
    chat: `<path stroke-linecap="round" stroke-linejoin="round" d="M20 14a4 4 0 0 1-4 4H9l-5 3V8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4z" /><path stroke-linecap="round" stroke-linejoin="round" d="M8 10h8" /><path stroke-linecap="round" stroke-linejoin="round" d="M8 13.5h5.5" />`,
    eye: `<path stroke-linecap="round" stroke-linejoin="round" d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z" /><circle cx="12" cy="12" r="2.5" />`,
    scale: `<path stroke-linecap="round" stroke-linejoin="round" d="M12 4v14" /><path stroke-linecap="round" stroke-linejoin="round" d="M6 8h12" /><path stroke-linecap="round" stroke-linejoin="round" d="M6 8l-2 4h4l-2-4z" /><path stroke-linecap="round" stroke-linejoin="round" d="M18 8l-2 4h4l-2-4z" /><path stroke-linecap="round" stroke-linejoin="round" d="M9 20h6" />`
};


// ─── Tamaños predefinidos ──────────────────────────────────────────────────────
const $aaf29492b6ca4e97$var$SIZES = {
    xs: {
        container: 'w-10 h-10',
        icon: 'w-5 h-5',
        padding: 'py-3 px-5',
        title: 'text-base font-medium'
    },
    sm: {
        container: 'w-10 h-10',
        icon: 'w-5 h-5',
        padding: 'p-6',
        title: 'text-xl font-semibold'
    },
    md: {
        container: 'w-14 h-14',
        icon: 'w-8 h-8',
        padding: 'p-6',
        title: 'text-xl font-semibold'
    },
    lg: {
        container: 'w-16 h-16',
        icon: 'w-10 h-10',
        padding: 'p-6',
        title: 'text-xl font-semibold'
    }
};
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-fam-card]").forEach((wrap)=>{
        const root = wrap.querySelector(".js-fam-card");
        if (!root) return;
        // 1. Elementos del DOM interno de fam-card.html
        const iconWrapper = root.querySelector(".js-fam-card-icon-wrapper");
        const iconSvg = root.querySelector(".js-fam-card-icon");
        const titleEl = root.querySelector(".js-fam-card-title");
        const textEl = root.querySelector(".js-fam-card-text");
        // 2. Leer propiedades pasadas por data-*
        const iconName = wrap.dataset.cardIcon; // Ya no tiene default porque puede ser un número
        const number = wrap.dataset.cardNumber;
        const title = wrap.dataset.cardTitle || '';
        const text = wrap.dataset.cardText || '';
        const align = wrap.dataset.cardAlign || 'center';
        const size = wrap.dataset.cardSize || 'md';
        const color = wrap.dataset.cardColor || 'primary'; // Por defecto, toma theme color primary
        // 3. Hidratar contenido
        if (number) {
            // Es una tarjeta numerada
            iconSvg.outerHTML = `<span class="js-fam-card-icon pointer-events-none font-bold text-white text-base md:text-xl">${number}</span>`;
            iconWrapper.classList.remove('bg-white/40', 'border', 'border-tinta/30');
            iconWrapper.classList.add(`bg-${color}`);
        } else {
            // Es una tarjeta con icono de la librería
            const iconKey = iconName || 'star';
            iconSvg.innerHTML = (0, $2880fb3dc6eeb637$export$fde44257752a9f60)[iconKey] || (0, $2880fb3dc6eeb637$export$fde44257752a9f60)['star'];
        }
        titleEl.textContent = title;
        if (text) textEl.innerHTML = text; // innerHTML por si el texto trae html como <br>
        else if (textEl) textEl.remove(); // Si no hay texto, quitamos el nodo p
        // 4. Adaptar colores y tamaños
        root.classList.remove('border-primary', 'p-6'); // Quitamos defaults del template
        root.classList.add(`border-${color}`);
        const { container: container, icon: icon, padding: padding, title: titleStyle } = $aaf29492b6ca4e97$var$SIZES[size] || $aaf29492b6ca4e97$var$SIZES['md'];
        iconWrapper.classList.add(...container.split(' '));
        if (!number) iconSvg.classList.add(...icon.split(' '));
        if (padding) root.classList.add(...padding.split(' '));
        if (titleStyle) {
            // Quitamos la configuración por defecto del HTML y añadimos la específica de tamaño
            titleEl.classList.remove('text-xl', 'font-semibold');
            titleEl.classList.add(...titleStyle.split(' '));
        }
        // 5. Motor de Layout (Basado en CSS Grid Plana)
        root.classList.add('grid');
        if (align === 'center') {
            // Todo centrado, uno debajo de otro
            root.classList.add('grid-cols-1', 'justify-items-center', 'text-center');
            titleEl.classList.add('mt-3', 'mb-2');
        } else if (align === 'left') {
            // Icono a la izquierda, título al lado; texto debajo ocupando 2 columnas
            root.classList.add('grid-cols-[auto_1fr]', 'gap-x-3', 'items-center', 'text-left');
            if (text) textEl.classList.add('col-span-2', 'mt-3');
        } else if (align === 'right') {
            // Icono a la derecha, título a la izq; texto debajo ocupando 2 columnas
            root.classList.add('grid-cols-[1fr_auto]', 'gap-x-3', 'items-center', 'text-right');
            iconWrapper.classList.add('col-start-2');
            titleEl.classList.add('col-start-1', 'row-start-1');
            if (text) textEl.classList.add('col-span-2', 'row-start-2', 'mt-3');
        } else if (align === 'side') {
            // Icono a la izq ocupando 2 filas completas. El título a la derecha y el texto debajo del título
            root.classList.add('grid-cols-[auto_1fr]', 'gap-x-3', 'items-start', 'text-left');
            iconWrapper.classList.add('row-span-2');
            titleEl.classList.add('col-start-2');
            if (text) textEl.classList.add('col-start-2', 'mt-1');
            // Forzamos alineación izquierda aunque esté justificado start
            titleEl.classList.add('text-left');
        }
        // 6. Revelar suavemente la tarjeta
        requestAnimationFrame(()=>{
            root.classList.remove("opacity-0");
        });
    });
});


// src/js/components/fam-course-card.js
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-course-card]").forEach((wrap)=>{
        const card = wrap.querySelector(".js-course-card");
        if (!card) return;
        const titleEl = card.querySelector(".js-course-card-title");
        const imgEl = card.querySelector(".js-course-card-img");
        const textEl = card.querySelector(".js-course-card-text");
        const pdfBtn = card.querySelector(".js-course-card-pdf");
        // Recoger los datos definidos en el wrapper HTML
        const title = wrap.dataset.courseTitle || "";
        const text = wrap.dataset.courseText || "";
        // El PDF se obtiene preferiblemente de una etiqueta <a> oculta para que Parcel pueda empaquetarlo
        const pdfAnchor = wrap.querySelector("a.js-course-pdf-asset");
        const pdfLink = pdfAnchor ? pdfAnchor.getAttribute("href") : (wrap.dataset.coursePdf || "").trim();
        // Obtener la imagen procesada por Parcel o de data attribute
        const asset = wrap.querySelector("img.js-course-asset");
        const src = asset ? asset.getAttribute("src") : wrap.dataset.courseImg || "";
        // Poblar datos con variables
        if (titleEl) titleEl.innerHTML = title;
        if (textEl) textEl.innerHTML = text;
        // Asignación con src y alt
        if (imgEl && src) {
            imgEl.src = src;
            // limpiamos tags HTML para usarlo libremente en el texto alt
            imgEl.alt = title.replace(/<[^>]+>/g, '') || "Curso de Fundaci\xf3n";
        }
        // Tratamiento del href al PDF del Dossier
        if (pdfBtn) {
            if (pdfLink && pdfLink !== "#") pdfBtn.href = pdfLink;
            else // Ocultar botón si no hay PDF
            pdfBtn.style.display = "none";
        }
    });
});


// src/js/components/course-modal.js
document.addEventListener("DOMContentLoaded", ()=>{
    const modal = document.getElementById("course-modal");
    if (!modal) return;
    const closeBtns = modal.querySelectorAll(".js-modal-close");
    const modalContent = modal.querySelector(".js-modal-content");
    const courseNameInput = document.getElementById("modal-course-name");
    const courseCodeInput = document.getElementById("modal-course-code");
    const form = document.getElementById("course-request-form");
    const submitBtn = document.getElementById("course-submit-btn");
    const btnText = document.getElementById("course-btn-text");
    const btnIcon = document.getElementById("course-btn-icon");
    const formPanel = document.getElementById("course-modal-form-panel");
    const successPanel = document.getElementById("course-modal-success-panel");
    const errorPanel = document.getElementById("course-modal-error-panel");
    const errorDetails = document.getElementById("course-error-details");
    const closeBtn = document.getElementById("course-success-close-btn");
    const countdownSpan = document.getElementById("course-countdown");
    const retryBtn = document.getElementById("course-retry-btn");
    let countdownInterval;
    // Abrir Modal
    const openModal = (courseTitle, courseCode)=>{
        clearInterval(countdownInterval);
        if (formPanel) formPanel.classList.remove("hidden");
        if (successPanel) successPanel.classList.add("hidden");
        if (errorPanel) errorPanel.classList.add("hidden");
        if (form) form.reset();
        if (courseNameInput) {
            // Netear el HTML interno por si tiene <strong> (ej: <strong class='text-tinta'>diagnóstico</strong>)
            const divClean = document.createElement("div");
            divClean.innerHTML = courseTitle;
            courseNameInput.value = divClean.textContent || divClean.innerText || "";
        }
        if (courseCodeInput) courseCodeInput.value = courseCode || "";
        // Mostrar visualmente
        modal.classList.remove("opacity-0", "pointer-events-none");
        modalContent.classList.remove("scale-95");
        modalContent.classList.add("scale-100");
        document.body.style.overflow = "hidden"; // Desactivar scroll del fondo
    };
    // Cerrar Modal
    const closeModal = ()=>{
        clearInterval(countdownInterval);
        modal.classList.add("opacity-0", "pointer-events-none");
        modalContent.classList.remove("scale-100");
        modalContent.classList.add("scale-95");
        document.body.style.overflow = ""; // Reactivar scroll
    };
    // Delegación de eventos para capturar el click en cualquier botón "Solicitar Información"
    document.addEventListener("click", (e)=>{
        const trigger = e.target.closest(".js-course-modal-trigger");
        if (trigger) {
            e.preventDefault(); // Prevenir salto al ancla si fuera un <a>
            // Buscar la tarjeta padre que contiene el Data Attribute real
            const card = trigger.closest("[data-course-card]");
            const title = card ? card.dataset.courseTitle : "Curso de Iniciaci\xf3n";
            const code = card ? card.dataset.courseCode : "";
            openModal(title, code);
        }
    });
    // Ejecutar cierre en botón X y click en Overlay
    closeBtns.forEach((btn)=>{
        btn.addEventListener("click", closeModal);
    });
    // --- Helpers ---
    function setLoading(loading) {
        if (!submitBtn) return;
        submitBtn.disabled = loading;
        if (loading) {
            if (btnText) btnText.textContent = "Enviando...";
            if (btnIcon) btnIcon.classList.add('hidden');
        } else {
            if (btnText) btnText.textContent = "Enviar Solicitud";
            if (btnIcon) btnIcon.classList.remove('hidden');
        }
    }
    function collectData() {
        if (!form) return {};
        const fd = new FormData(form);
        const data = {};
        for (const [key, value] of fd.entries())data[key] = value;
        return data;
    }
    const startCountdown = ()=>{
        let seconds = 5;
        if (countdownSpan) countdownSpan.textContent = seconds;
        clearInterval(countdownInterval);
        countdownInterval = setInterval(()=>{
            seconds--;
            if (countdownSpan) countdownSpan.textContent = seconds;
            if (seconds <= 0) {
                clearInterval(countdownInterval);
                closeModal();
            }
        }, 1000);
    };
    // --- Envío ---
    if (form) form.addEventListener("submit", async (e)=>{
        e.preventDefault();
        try {
            setLoading(true);
            const data = collectData();
            // reCAPTCHA v3
            if (typeof grecaptcha !== 'undefined') {
                const siteKey = "6LfRO-gsAAAAAHeuL2kO3p2XT7QVQVJYRP3QM8FL";
                data.recaptchaToken = await grecaptcha.execute(siteKey, {
                    action: 'course_request'
                });
            }
            const response = await fetch("/.netlify/functions/send-info-curso", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const errorBody = await response.json().catch(()=>({}));
                throw new Error(errorBody.details || `Error ${response.status}`);
            }
            // Éxito
            setLoading(false);
            if (formPanel) formPanel.classList.add("hidden");
            if (successPanel) successPanel.classList.remove("hidden");
            startCountdown();
        } catch (err) {
            console.error("Error al enviar solicitud:", err);
            setLoading(false);
            if (errorDetails) errorDetails.textContent = `No hemos podido procesar tu solicitud: ${err.message}`;
            if (formPanel) formPanel.classList.add("hidden");
            if (errorPanel) errorPanel.classList.remove("hidden");
        }
    });
    if (closeBtn) closeBtn.addEventListener("click", ()=>{
        clearInterval(countdownInterval);
        closeModal();
    });
    if (retryBtn) retryBtn.addEventListener("click", ()=>{
        if (errorPanel) errorPanel.classList.add("hidden");
        if (formPanel) formPanel.classList.remove("hidden");
        setLoading(false);
    });
});


// src/js/components/enrollment-modal.js
document.addEventListener("DOMContentLoaded", ()=>{
    const modal = document.getElementById("enrollment-modal");
    if (!modal) return;
    const modalContent = modal.querySelector(".js-enroll-modal-content");
    const formPanel = document.getElementById("enroll-modal-form-panel");
    const successPanel = document.getElementById("enroll-modal-success-panel");
    const errorPanel = document.getElementById("enroll-modal-error-panel");
    const errorMsg = document.getElementById("enroll-error-msg");
    const errorText = document.getElementById("enroll-send-error-text");
    const form = document.getElementById("enrollment-form");
    const submitBtn = document.getElementById("enroll-submit-btn");
    const btnText = document.getElementById("enroll-btn-text");
    const btnIcon = document.getElementById("enroll-btn-icon");
    const btnSpinner = document.getElementById("enroll-btn-spinner");
    const retryBtn = document.getElementById("enroll-retry-btn");
    const courseNameInput = document.getElementById("enroll-course-name");
    const courseCodeInput = document.getElementById("enroll-course-code");
    // --- Abrir / Cerrar modal ---
    const openModal = (courseTitle, courseCode)=>{
        // Reset estado
        [
            formPanel,
            errorMsg
        ].forEach((el)=>el && el.classList.remove("hidden"));
        [
            successPanel,
            errorPanel
        ].forEach((el)=>el && el.classList.add("hidden"));
        if (form) form.reset();
        resetConditionalFields();
        // Set course info
        if (courseNameInput) {
            const divClean = document.createElement("div");
            divClean.innerHTML = courseTitle || "Curso de Formaci\xf3n";
            courseNameInput.value = divClean.textContent || divClean.innerText || "";
        }
        if (courseCodeInput) courseCodeInput.value = (courseCode || "").toUpperCase();
        modal.classList.remove("opacity-0", "pointer-events-none");
        modalContent.classList.remove("scale-95");
        modalContent.classList.add("scale-100");
        document.body.style.overflow = "hidden";
        modal.scrollTop = 0;
    };
    const closeModal = ()=>{
        modal.classList.add("opacity-0", "pointer-events-none");
        modalContent.classList.remove("scale-100");
        modalContent.classList.add("scale-95");
        document.body.style.overflow = "";
    };
    // --- Triggers ---
    document.addEventListener("click", (e)=>{
        const trigger = e.target.closest(".js-enrollment-modal-trigger");
        if (trigger) {
            e.preventDefault();
            const card = trigger.closest("[data-course-card]");
            const title = card ? card.dataset.courseTitle : "";
            const code = card ? card.dataset.courseCode : "";
            openModal(title, code);
        }
    });
    modal.querySelectorAll(".js-enroll-modal-close").forEach((btn)=>{
        btn.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && !modal.classList.contains("pointer-events-none")) closeModal();
    });
    // --- Lógica de campos condicionales ---
    const expWrapper = document.getElementById("wrapper-experiencia-desc");
    const expRadios = form.querySelectorAll('input[name="experiencia_previa"]');
    function resetConditionalFields() {
        if (expWrapper) expWrapper.classList.add("hidden");
    }
    expRadios.forEach((radio)=>{
        radio.addEventListener("change", ()=>{
            if (radio.value === "S\xed") expWrapper.classList.remove("hidden");
            else expWrapper.classList.add("hidden");
        });
    });
    // Manejo de "Otros"
    const otherTriggers = form.querySelectorAll(".js-enroll-other-trigger");
    otherTriggers.forEach((trigger)=>{
        const targetId = trigger.dataset.target;
        const targetInput = document.getElementById(targetId);
        trigger.addEventListener("change", ()=>{
            if (trigger.checked) setTimeout(()=>targetInput.focus(), 50);
        });
        const groupName = trigger.name;
        const groupRadios = form.querySelectorAll(`input[name="${groupName}"]`);
        groupRadios.forEach((radio)=>{
            if (radio !== trigger) radio.addEventListener("change", ()=>{
                if (targetInput) targetInput.value = "";
            });
        });
    });
    // --- Reintentar ---
    if (retryBtn) retryBtn.addEventListener("click", ()=>{
        errorPanel.classList.add("hidden");
        formPanel.classList.remove("hidden");
        setLoading(false);
    });
    // --- Helpers ---
    function setLoading(loading) {
        if (!submitBtn) return;
        submitBtn.disabled = loading;
        if (btnText) btnText.textContent = loading ? "Enviando..." : "Solicitar inscripci\xf3n";
        if (btnIcon) btnIcon.classList.toggle("hidden", loading);
        if (btnSpinner) btnSpinner.classList.toggle("hidden", !loading);
    }
    function validate() {
        let valid = true;
        const requiredTexts = [
            "nombre",
            "dni",
            "fecha_nacimiento",
            "direccion",
            "telefono",
            "email",
            "motivacion"
        ];
        requiredTexts.forEach((name)=>{
            const el = form.querySelector(`[name="${name}"]`);
            if (el && !el.value.trim()) valid = false;
        });
        const emailEl = form.querySelector('[name="email"]');
        if (emailEl && emailEl.value && !emailEl.value.includes("@")) valid = false;
        const radioGroups = [
            "nivel_estudios",
            "situacion_actual",
            "experiencia_previa",
            "canal_conocimiento"
        ];
        radioGroups.forEach((name)=>{
            const checked = [
                ...form.querySelectorAll(`input[name="${name}"]`)
            ].some((r)=>r.checked);
            if (!checked) valid = false;
        });
        const priv = form.querySelector('[name="acepta_privacidad"]');
        const conf = form.querySelector('[name="confirma_datos"]');
        if (priv && !priv.checked) valid = false;
        if (conf && !conf.checked) valid = false;
        return valid;
    }
    function collectData() {
        const fd = new FormData(form);
        const data = {};
        for (const [key, value] of fd.entries())data[key] = value;
        // Sustituir "Otros" por valor del input si aplica
        const otherMappings = [
            {
                radioId: "nivel-otros-check",
                textId: "nivel_estudios_otros",
                key: "nivel_estudios"
            },
            {
                radioId: "situacion-otros-check",
                textId: "situacion_actual_otros",
                key: "situacion_actual"
            },
            {
                radioId: "canal-otros-check",
                textId: "conociste_otros",
                key: "canal_conocimiento"
            }
        ];
        otherMappings.forEach((m)=>{
            const radio = document.getElementById(m.radioId);
            const text = document.getElementById(m.textId);
            if (radio && radio.checked && text && text.value.trim()) data[m.key] = `Otros: ${text.value.trim()}`;
        });
        return data;
    }
    // --- Envío ---
    if (form) form.addEventListener("submit", async (e)=>{
        e.preventDefault();
        if (errorMsg) errorMsg.classList.add("hidden");
        if (!validate()) {
            if (errorMsg) {
                errorMsg.classList.remove("hidden");
                errorMsg.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
            return;
        }
        setLoading(true);
        const data = collectData();
        // reCAPTCHA v3
        if (typeof grecaptcha !== 'undefined') {
            const siteKey = "6LfRO-gsAAAAAHeuL2kO3p2XT7QVQVJYRP3QM8FL";
            data.recaptchaToken = await grecaptcha.execute(siteKey, {
                action: 'enrollment'
            });
        }
        try {
            const response = await fetch("/.netlify/functions/send-cursos", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`Error ${response.status}`);
            setLoading(false);
            formPanel.classList.add("hidden");
            successPanel.classList.remove("hidden");
            modal.scrollTop = 0;
        } catch (err) {
            console.error("Error al enviar inscripci\xf3n:", err);
            setLoading(false);
            if (errorText) errorText.textContent = "Ha ocurrido un problema al enviar tu inscripci\xf3n. Por favor, int\xe9ntalo de nuevo.";
            formPanel.classList.add("hidden");
            errorPanel.classList.remove("hidden");
            modal.scrollTop = 0;
        }
    });
});


// src/js/components/fam-doc-card.js
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-doc-card]").forEach((wrap)=>{
        const card = wrap.querySelector(".js-doc-card");
        if (!card) return;
        const titleEl = card.querySelector(".js-doc-title");
        const textEl = card.querySelector(".js-doc-text");
        const iconWrap = card.querySelector(".js-doc-icon-wrap");
        const icon = card.querySelector(".js-doc-icon");
        const linkEl = card.querySelector(".js-doc-link");
        const disabledEl = card.querySelector(".js-doc-disabled");
        // Recoger textos
        const title = wrap.dataset.title || "";
        const text = wrap.dataset.text || "";
        const theme = wrap.dataset.theme || "primary"; // primary, accent, gray
        // Obtener enlace nativo para compatibilidad con Parcel
        const linkAnchor = wrap.querySelector("a.js-doc-asset");
        const link = linkAnchor ? linkAnchor.getAttribute("href") : wrap.dataset.link || "";
        if (titleEl) titleEl.textContent = title;
        if (textEl) textEl.textContent = text;
        // Aplicar estilos del tema (Primary por defecto)
        if (theme === "primary") {
            card.classList.add("border-gray-100");
            iconWrap.classList.add("bg-primary/10");
            icon.classList.add("text-primary");
            titleEl.classList.add("text-tinta");
            textEl.classList.add("text-text-main/70");
            linkEl.classList.add("bg-text-main", "hover:bg-primary");
        } else if (theme === "accent") {
            card.classList.add("border-gray-100");
            iconWrap.classList.add("bg-accent/10");
            icon.classList.add("text-accent");
            titleEl.classList.add("text-tinta");
            textEl.classList.add("text-text-main/70");
            linkEl.classList.add("bg-text-main", "hover:bg-accent");
        } else if (theme === "gray") {
            card.classList.add("border-dashed", "border-gray-300");
            iconWrap.classList.add("bg-gray-200");
            icon.classList.add("text-gray-500");
            titleEl.classList.add("text-gray-600");
            textEl.classList.add("text-text-main/50", "italic");
        }
        // Gestionar renderizado condicional de botón
        if (link && link !== "#" && theme !== "gray") {
            linkEl.href = link;
            linkEl.style.display = "inline-flex";
            disabledEl.style.display = "none";
        } else {
            linkEl.style.display = "none";
            disabledEl.style.display = "inline-flex";
        }
    });
});


// src/js/components/fam-colabora-item.js
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-colabora-item]").forEach((wrap)=>{
        const card = wrap.querySelector(".js-colabora-card");
        if (!card) return;
        const titleEl = card.querySelector(".js-colabora-title");
        const subtitleEl = card.querySelector(".js-colabora-subtitle");
        const imgEl = card.querySelector(".js-colabora-img");
        const bodyEl = card.querySelector(".js-colabora-body");
        // Configuraciones por data-attributes
        const title = wrap.dataset.title || "";
        const subtitle = wrap.dataset.subtitle || "";
        const reverse = wrap.dataset.reverse === "true";
        // Nodos de contenido HTML aportados por el usuario
        const contentSrc = wrap.querySelector(".js-colabora-content");
        const imageSrc = wrap.querySelector("img.js-colabora-asset");
        // Inyectar Textos
        if (titleEl) titleEl.textContent = title;
        if (subtitleEl) subtitleEl.textContent = subtitle;
        // Inyectar Imagen
        if (imgEl && imageSrc) {
            imgEl.src = imageSrc.src;
            imgEl.alt = title;
        } else if (imgEl) {
            imgEl.style.display = 'none';
            card.querySelector('.lg\\:w-2\\/5').style.display = 'none';
            card.querySelector('.lg\\:w-3\\/5').classList.remove('lg:w-3/5', 'xl:w-7/12');
            card.querySelector('.lg\\:w-3\\/5').classList.add('w-full');
        }
        // Inyectar Cuerpo HTML
        if (bodyEl && contentSrc) bodyEl.innerHTML = contentSrc.innerHTML;
        // Gestionar Reverso para layout intercalado
        if (reverse) {
            card.classList.remove("lg:flex-row");
            card.classList.add("lg:flex-row-reverse");
        }
    });
});


// src/js/components/random-phrase.js
const $8da2d45c5e0ca2c0$export$4db04df6668ddaa9 = [
    "Creemos en tu momento.",
    "Transformando momentos en oportunidades.",
    "Porque cada persona tiene su momento.",
    "El poder de una oportunidad.",
    "Tu momento empieza aqu\xed.",
    "El momento que cambia tu historia.",
    "Porque cada momento merece una oportunidad."
];


document.addEventListener("DOMContentLoaded", ()=>{
    const containers = document.querySelectorAll(".js-random-phrase");
    // Aborta si no hay frase.json o no hay contenedor en el HTML actual (ej: index.html)
    if (!containers.length || !(0, $8da2d45c5e0ca2c0$export$4db04df6668ddaa9) || (0, $8da2d45c5e0ca2c0$export$4db04df6668ddaa9).length === 0) return;
    // Seleccionar una frase aleatoria del array
    const randomIndex = Math.floor(Math.random() * (0, $8da2d45c5e0ca2c0$export$4db04df6668ddaa9).length);
    const fraseSeleccionada = (0, $8da2d45c5e0ca2c0$export$4db04df6668ddaa9)[randomIndex];
    // Inyectar en los nodos
    containers.forEach((container)=>{
        container.textContent = fraseSeleccionada;
    });
});


// src/js/components/fam-icon-box.js

document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-icon-box]").forEach((wrap)=>{
        const root = wrap.querySelector(".js-icon-box");
        if (!root) return;
        const wrapEl = root.querySelector(".js-icon-wrap");
        const svgEl = root.querySelector(".js-icon-svg");
        const titleEl = root.querySelector(".js-icon-title");
        const icon = wrap.dataset.boxIcon || "heart";
        const color = wrap.dataset.boxColor || "primary";
        const title = wrap.dataset.boxTitle || "";
        if (titleEl) titleEl.textContent = title;
        if (svgEl) svgEl.innerHTML = (0, $2880fb3dc6eeb637$export$fde44257752a9f60)[icon] || (0, $2880fb3dc6eeb637$export$fde44257752a9f60)['heart'];
        // Colores dinámicos
        root.classList.add(`border-t-4`, `border-t-${color}`);
        wrapEl.classList.add(`bg-${color}/10`);
        svgEl.classList.add(`text-${color}`);
    });
});


// src/js/components/voluntariado-modal.js
document.addEventListener('DOMContentLoaded', ()=>{
    const modal = document.getElementById('voluntariado-modal');
    if (!modal) return;
    const modalContent = modal.querySelector('.js-vol-modal-content');
    const formPanel = document.getElementById('vol-modal-form-panel');
    const successPanel = document.getElementById('vol-modal-success-panel');
    const errorPanel = document.getElementById('vol-modal-error-panel');
    const errorMsg = document.getElementById('vol-error-msg');
    const errorText = document.getElementById('vol-send-error-text');
    const form = document.getElementById('voluntariado-form');
    const submitBtn = document.getElementById('vol-submit-btn');
    const btnText = document.getElementById('vol-btn-text');
    const btnIcon = document.getElementById('vol-btn-icon');
    const btnSpinner = document.getElementById('vol-btn-spinner');
    const retryBtn = document.getElementById('vol-retry-btn');
    // ── Abrir / Cerrar modal ──────────────────────────────────────────
    const openModal = ()=>{
        // Aseguramos el estado de inicio
        [
            formPanel,
            errorMsg
        ].forEach((el)=>el && el.classList.remove('hidden'));
        [
            successPanel,
            errorPanel
        ].forEach((el)=>el && el.classList.add('hidden'));
        if (form) form.reset();
        resetExpDetalle();
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modalContent.classList.remove('scale-95');
        modalContent.classList.add('scale-100');
        document.body.style.overflow = 'hidden';
        // Scroll al inicio del modal
        modal.scrollTop = 0;
        // Ocultar error de validación al abrir
        if (errorMsg) errorMsg.classList.add('hidden');
    };
    const closeModal = ()=>{
        modal.classList.add('opacity-0', 'pointer-events-none');
        modalContent.classList.remove('scale-100');
        modalContent.classList.add('scale-95');
        document.body.style.overflow = '';
    };
    // ── Trigger: botón "HAZTE VOLUNTARIO" ────────────────────────────
    document.addEventListener('click', (e)=>{
        const trigger = e.target.closest('.js-vol-modal-trigger');
        if (trigger) {
            e.preventDefault();
            openModal();
        }
    });
    // ── Botones de cierre ─────────────────────────────────────────────
    modal.querySelectorAll('.js-vol-modal-close').forEach((btn)=>{
        btn.addEventListener('click', closeModal);
    });
    // Delegación para el botón de cierre del panel de éxito
    // (se añade al panel para capturar el botón dinámico)
    if (successPanel) successPanel.addEventListener('click', (e)=>{
        if (e.target.closest('.js-vol-modal-close')) closeModal();
    });
    // Escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && !modal.classList.contains('pointer-events-none')) closeModal();
    });
    // ── Campo experiencia condicional ─────────────────────────────────
    const expSi = document.getElementById('exp-si');
    const expNo = document.getElementById('exp-no');
    const expDet = document.getElementById('vol-exp-detalle');
    function resetExpDetalle() {
        if (expDet) expDet.classList.add('hidden');
    }
    [
        expSi,
        expNo
    ].forEach((radio)=>{
        if (!radio) return;
        radio.addEventListener('change', ()=>{
            if (!expDet) return;
            expDet.classList.toggle('hidden', !expSi.checked);
        });
    });
    // ── Reintentar ────────────────────────────────────────────────────
    if (retryBtn) retryBtn.addEventListener('click', ()=>{
        errorPanel.classList.add('hidden');
        formPanel.classList.remove('hidden');
        setLoading(false);
    });
    // ── Helpers ───────────────────────────────────────────────────────
    function setLoading(loading) {
        if (!submitBtn) return;
        submitBtn.disabled = loading;
        if (btnText) btnText.textContent = loading ? 'Enviando...' : 'Enviar solicitud';
        if (btnIcon) btnIcon.classList.toggle('hidden', loading);
        if (btnSpinner) btnSpinner.classList.toggle('hidden', !loading);
    }
    function collectData() {
        if (!form) return {};
        const fd = new FormData(form);
        const multiFields = [
            'disponibilidad',
            'areas',
            'preferencia_contacto'
        ];
        const data = {};
        for (const [key, value] of fd.entries())if (multiFields.includes(key)) {
            if (!data[key]) data[key] = [];
            data[key].push(value);
        } else data[key] = value;
        // Sustituir "Otras" por el texto libre si está marcado
        const otrasCheck = document.getElementById('areas-otras-check');
        const otrasTexto = document.getElementById('areas-otras-texto');
        if (otrasCheck && otrasCheck.checked && otrasTexto && otrasTexto.value.trim()) {
            if (!data['areas']) data['areas'] = [];
            const idx = data['areas'].indexOf('Otras');
            if (idx !== -1) data['areas'][idx] = `Otras: ${otrasTexto.value.trim()}`;
        }
        return data;
    }
    function validate() {
        let valid = true;
        // Campos de texto / fecha obligatorios
        [
            'nombre',
            'fecha_nacimiento',
            'dni',
            'ciudad',
            'telefono',
            'email'
        ].forEach((name)=>{
            const el = form.querySelector(`[name="${name}"]`);
            if (el && !el.value.trim()) valid = false;
        });
        // Email con @
        const emailEl = form.querySelector('[name="email"]');
        if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;
        // Radio groups obligatorios
        [
            'horas_semanales',
            'duracion',
            'experiencia_previa',
            'certificado_delitos'
        ].forEach((name)=>{
            const checked = [
                ...form.querySelectorAll(`[name="${name}"]`)
            ].some((r)=>r.checked);
            if (!checked) valid = false;
        });
        // Checkboxes de autorización
        const priv = document.getElementById('vol-privacidad');
        const conf = document.getElementById('vol-confirmacion');
        if (priv && !priv.checked) valid = false;
        if (conf && !conf.checked) valid = false;
        return valid;
    }
    // ── Envío ─────────────────────────────────────────────────────────
    if (form) form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        if (errorMsg) errorMsg.classList.add('hidden');
        if (!validate()) {
            if (errorMsg) {
                errorMsg.classList.remove('hidden');
                errorMsg.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
            return;
        }
        const data = collectData();
        // reCAPTCHA v3
        if (typeof grecaptcha !== 'undefined') {
            const siteKey = "6LfRO-gsAAAAAHeuL2kO3p2XT7QVQVJYRP3QM8FL";
            data.recaptchaToken = await grecaptcha.execute(siteKey, {
                action: 'voluntariado'
            });
        }
        setLoading(true);
        try {
            const response = await fetch('/.netlify/functions/send-voluntariado', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const body = await response.json().catch(()=>({}));
                throw new Error(body.message || `Error ${response.status}`);
            }
            // Éxito
            setLoading(false);
            formPanel.classList.add('hidden');
            successPanel.classList.remove('hidden');
            modal.scrollTop = 0;
        } catch (err) {
            console.error('Error al enviar formulario de voluntariado:', err);
            setLoading(false);
            if (errorText) errorText.textContent = err.message || "Error inesperado. Por favor, int\xe9ntalo de nuevo.";
            formPanel.classList.add('hidden');
            errorPanel.classList.remove('hidden');
            modal.scrollTop = 0;
        }
    });
});


// src/js/components/donar-modal.js
document.addEventListener('DOMContentLoaded', ()=>{
    const modal = document.getElementById('donar-modal');
    if (!modal) return;
    const modalContent = modal.querySelector('.js-donar-modal-content');
    const formPanel = document.getElementById('donar-modal-form-panel');
    const successPanel = document.getElementById('donar-modal-success-panel');
    const errorPanel = document.getElementById('donar-modal-error-panel');
    const errorMsg = document.getElementById('donar-error-msg');
    const errorText = document.getElementById('donar-send-error-text');
    const form = document.getElementById('donar-form');
    const submitBtn = document.getElementById('donar-submit-btn');
    const btnText = document.getElementById('donar-btn-text');
    const btnIcon = document.getElementById('donar-btn-icon');
    const btnSpinner = document.getElementById('donar-btn-spinner');
    const retryBtn = document.getElementById('donar-retry-btn');
    // Campos particular / empresa
    const particularFields = document.getElementById('don-particular-fields');
    const empresaFields = document.getElementById('don-empresa-fields');
    // Opciones tipo donante
    const tipoParticular = document.getElementById('don-tipo-particular');
    const tipoEmpresa = document.getElementById('don-tipo-empresa');
    // Wrap importe personalizado
    const importeCustomWrap = document.getElementById('don-importe-custom-wrap');
    const importeCustom = document.getElementById('don-importe-custom');
    // ── Apertura / Cierre ──────────────────────────────────────────────
    const openModal = ()=>{
        [
            formPanel,
            errorMsg
        ].forEach((el)=>el && el.classList.remove('hidden'));
        [
            successPanel,
            errorPanel
        ].forEach((el)=>el && el.classList.add('hidden'));
        if (form) form.reset();
        switchTipo('particular');
        if (importeCustomWrap) importeCustomWrap.classList.add('hidden');
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modalContent.classList.remove('scale-95');
        modalContent.classList.add('scale-100');
        document.body.style.overflow = 'hidden';
        modal.scrollTop = 0;
        if (errorMsg) errorMsg.classList.add('hidden');
    };
    const closeModal = ()=>{
        modal.classList.add('opacity-0', 'pointer-events-none');
        modalContent.classList.remove('scale-100');
        modalContent.classList.add('scale-95');
        document.body.style.overflow = '';
    };
    // ── Trigger botón ─────────────────────────────────────────────────
    document.addEventListener('click', (e)=>{
        const trigger = e.target.closest('.js-donar-modal-trigger');
        if (trigger) {
            e.preventDefault();
            openModal();
        }
    });
    // ── Cerrar modal ──────────────────────────────────────────────────
    modal.querySelectorAll('.js-donar-modal-close').forEach((btn)=>{
        btn.addEventListener('click', closeModal);
    });
    if (successPanel) successPanel.addEventListener('click', (e)=>{
        if (e.target.closest('.js-donar-modal-close')) closeModal();
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && !modal.classList.contains('pointer-events-none')) closeModal();
    });
    // ── Switch Particular / Empresa ───────────────────────────────────
    function switchTipo(tipo) {
        if (tipo === 'empresa') {
            if (particularFields) particularFields.classList.add('hidden');
            if (empresaFields) empresaFields.classList.remove('hidden');
        } else {
            if (particularFields) particularFields.classList.remove('hidden');
            if (empresaFields) empresaFields.classList.add('hidden');
        }
    }
    [
        tipoParticular,
        tipoEmpresa
    ].forEach((radio)=>{
        if (!radio) return;
        radio.addEventListener('change', ()=>{
            switchTipo(radio.value);
        });
    });
    // ── Importe personalizado ─────────────────────────────────────────
    if (form) form.querySelectorAll('[name="importe_opcion"]').forEach((radio)=>{
        radio.addEventListener('change', ()=>{
            if (importeCustomWrap) {
                importeCustomWrap.classList.toggle('hidden', radio.value !== 'otro');
                if (radio.value !== 'otro' && importeCustom) importeCustom.value = '';
            }
        });
    });
    // ── Retry ─────────────────────────────────────────────────────────
    if (retryBtn) retryBtn.addEventListener('click', ()=>{
        if (errorPanel) errorPanel.classList.add('hidden');
        if (formPanel) formPanel.classList.remove('hidden');
        setLoading(false);
    });
    // ── Helpers ───────────────────────────────────────────────────────
    function setLoading(loading) {
        if (!submitBtn) return;
        submitBtn.disabled = loading;
        if (btnText) btnText.textContent = loading ? 'Enviando...' : "Enviar solicitud de donaci\xf3n";
        if (btnIcon) btnIcon.classList.toggle('hidden', loading);
        if (btnSpinner) btnSpinner.classList.toggle('hidden', !loading);
    }
    function getTipoDonante() {
        return tipoEmpresa && tipoEmpresa.checked ? 'empresa' : 'particular';
    }
    function getImporte() {
        if (!form) return '';
        const checkedOpcion = form.querySelector('[name="importe_opcion"]:checked');
        if (!checkedOpcion) return '';
        if (checkedOpcion.value === 'otro') return importeCustom ? importeCustom.value.trim() : '';
        return checkedOpcion.value;
    }
    function collectData() {
        if (!form) return {};
        const fd = new FormData(form);
        const data = {};
        for (const [key, value] of fd.entries())data[key] = value;
        data.tipo_donante = getTipoDonante();
        data.importe = getImporte();
        return data;
    }
    function validate() {
        let valid = true;
        const tipo = getTipoDonante();
        if (tipo === 'particular') {
            [
                'nombre',
                'apellidos',
                'email',
                'fecha_nacimiento',
                'dni',
                'telefono1',
                'domicilio',
                'numero',
                'localidad',
                'codigo_postal',
                'provincia'
            ].forEach((name)=>{
                const el = form.querySelector(`[name="${name}"]`);
                if (el && !el.value.trim()) valid = false;
            });
            const emailEl = form.querySelector('[name="email"]');
            if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;
        } else {
            [
                'empresa_nombre',
                'empresa_contacto_nombre',
                'empresa_contacto_apellidos',
                'empresa_email',
                'empresa_telefono',
                'empresa_cif',
                'empresa_domicilio'
            ].forEach((name)=>{
                const el = form.querySelector(`[name="${name}"]`);
                if (el && !el.value.trim()) valid = false;
            });
            const emailEl = form.querySelector('[name="empresa_email"]');
            if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;
        }
        // Objetivo obligatorio
        const objetivo = form.querySelector('[name="objetivo"]:checked');
        if (!objetivo) valid = false;
        // Importe obligatorio
        const importeOpc = form.querySelector('[name="importe_opcion"]:checked');
        if (!importeOpc) valid = false;
        else if (importeOpc.value === 'otro') {
            if (!importeCustom || !importeCustom.value.trim() || Number(importeCustom.value) < 1) valid = false;
        }
        return valid;
    }
    // ── Envío ─────────────────────────────────────────────────────────
    if (form) form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        if (errorMsg) errorMsg.classList.add('hidden');
        if (!validate()) {
            if (errorMsg) {
                errorMsg.classList.remove('hidden');
                errorMsg.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
            return;
        }
        const data = collectData();
        // reCAPTCHA v3
        if (typeof grecaptcha !== 'undefined') {
            const siteKey = "6LfRO-gsAAAAAHeuL2kO3p2XT7QVQVJYRP3QM8FL";
            data.recaptchaToken = await grecaptcha.execute(siteKey, {
                action: 'donation'
            });
        }
        setLoading(true);
        try {
            const response = await fetch('/.netlify/functions/send-donar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const body = await response.json().catch(()=>({}));
                throw new Error(body.message || `Error ${response.status}`);
            }
            setLoading(false);
            if (formPanel) formPanel.classList.add('hidden');
            if (successPanel) successPanel.classList.remove('hidden');
            modal.scrollTop = 0;
        } catch (err) {
            console.error("Error al enviar formulario de donaci\xf3n:", err);
            setLoading(false);
            if (errorText) errorText.textContent = err.message || "Error inesperado. Por favor, int\xe9ntalo de nuevo.";
            if (formPanel) formPanel.classList.add('hidden');
            if (errorPanel) errorPanel.classList.remove('hidden');
            modal.scrollTop = 0;
        }
    });
});


// Inicialización de componentes globales
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $5a4ef64b89c7976a$export$c0f66b9778462a6f).init();
    $d706c914d748cb55$var$loadReCaptcha();
});
/**
 * Carga dinámicamente el script de Google reCAPTCHA v3
 */ function $d706c914d748cb55$var$loadReCaptcha() {
    const siteKey = "6LfRO-gsAAAAAHeuL2kO3p2XT7QVQVJYRP3QM8FL";
    if (!siteKey || siteKey.includes('placeholder')) console.warn('reCAPTCHA: Site Key no configurada o usando placeholder.');
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
}
// ==================================================================
// Menú de navegación familiar
// ==================================================================
document.addEventListener("DOMContentLoaded", ()=>{
    const btn = document.getElementById("famMenuBtn");
    const menu = document.getElementById("famMenu");
    if (!btn || !menu) return;
    btn.addEventListener("click", ()=>{
        menu.classList.toggle("hidden");
        btn.setAttribute("aria-expanded", menu.classList.contains("hidden") ? "false" : "true");
    });
});
// ==================================================================
// Submenús acordeón (header-v2 · menú móvil)
// ==================================================================
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".js-submenu-toggle").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const submenu = btn.nextElementSibling;
            if (!submenu || !submenu.classList.contains("js-submenu")) return;
            const isOpen = !submenu.classList.contains("hidden");
            // Cerrar todos los submenús abiertos
            document.querySelectorAll(".js-submenu").forEach((s)=>{
                s.classList.add("hidden");
            });
            document.querySelectorAll(".js-submenu-toggle").forEach((b)=>{
                b.setAttribute("aria-expanded", "false");
                const arrow = b.querySelector(".js-submenu-arrow");
                if (arrow) arrow.classList.remove("rotate-180");
            });
            // Si estaba cerrado, abrirlo
            if (!isOpen) {
                submenu.classList.remove("hidden");
                btn.setAttribute("aria-expanded", "true");
                const arrow = btn.querySelector(".js-submenu-arrow");
                if (arrow) arrow.classList.add("rotate-180");
            }
        });
    });
    // Para submenús anidados (nivel 2)
    document.querySelectorAll(".js-submenu-toggle-nested").forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            e.stopPropagation();
            const submenu = btn.nextElementSibling;
            if (!submenu || !submenu.classList.contains("js-submenu-nested")) return;
            const isOpen = !submenu.classList.contains("hidden");
            if (!isOpen) {
                submenu.classList.remove("hidden");
                btn.setAttribute("aria-expanded", "true");
                const arrow = btn.querySelector(".js-submenu-arrow-nested");
                if (arrow) arrow.classList.add("rotate-180");
            } else {
                submenu.classList.add("hidden");
                btn.setAttribute("aria-expanded", "false");
                const arrow = btn.querySelector(".js-submenu-arrow-nested");
                if (arrow) arrow.classList.remove("rotate-180");
            }
        });
    });
});
// ==================================================================
// Año dinámico (footer-autor.html)
// ==================================================================
document.querySelectorAll(".js-year").forEach((el)=>{
    el.textContent = new Date().getFullYear();
});
// ==================================================================
// Componente card-image.html (tarjeta con imagen, título y texto)
// ==================================================================
document.querySelectorAll("[data-card-title]").forEach((wrap)=>{
    const card = wrap.querySelector(".js-card-image");
    if (!card) return;
    const img = card.querySelector(".js-card-image-img");
    const titleEl = card.querySelector(".js-card-image-title");
    const textEl = card.querySelector(".js-card-image-text");
    const ctaEl = card.querySelector(".js-card-image-cta");
    const titleBar = card.querySelector(".js-card-titlebar");
    const asset = wrap.querySelector("img.js-card-asset");
    const src = asset ? asset.getAttribute("src") : "";
    const alt = wrap.dataset.cardAlt || "";
    const title = wrap.dataset.cardTitle || "";
    const text = wrap.dataset.cardText || "";
    const link = (wrap.dataset.cardLink || "").trim();
    // Imagen
    if (img && src) {
        img.setAttribute("src", src);
        img.setAttribute("alt", alt || title);
    }
    // Texto
    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;
    // CTA: oculto por defecto
    if (ctaEl) ctaEl.style.display = "none";
    // Reset visual (por si se reinicializa)
    card.classList.remove("cursor-pointer", "hover:border-accent", "hover:border-[4px]");
    if (titleBar) titleBar.classList.remove("transition-colors", "duration-300", "group-hover:bg-accent");
    // Reset accesibilidad
    card.removeAttribute("role");
    card.removeAttribute("tabindex");
    if (link) {
        // Mostrar CTA
        if (ctaEl) ctaEl.style.display = "";
        // Card clicable + hover SOLO si hay link
        card.classList.add("cursor-pointer", "hover:border-accent", "hover:border-[4px]");
        // Hover franja título SOLO si hay link
        if (titleBar) titleBar.classList.add("group-hover:bg-accent");
        // Accesibilidad
        card.setAttribute("role", "link");
        card.setAttribute("tabindex", "0");
        // Evitar duplicar listeners
        if (!card.dataset.cardBound) {
            card.addEventListener("click", ()=>{
                window.location.href = link;
            });
            card.addEventListener("keydown", (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    window.location.href = link;
                }
            });
            card.dataset.cardBound = "1";
        }
    }
});
// ==================================================================
// Componente hero-index (parametrizado + CTA opcional)
// Uso: wrapper con [data-hero] y dentro el <section class="js-hero">...
// Params (data-*):
// - data-hero-src, data-hero-alt
// - data-hero-title, data-hero-subtitle
// - data-hero-cta-label, data-hero-cta-link
// - data-hero-overlay (opcional): "0.30" | "30" | "bg-black/40" etc.
// ==================================================================
document.querySelectorAll("[data-hero]").forEach((wrap)=>{
    const root = wrap.querySelector(".js-hero");
    if (!root) return;
    const img = root.querySelector(".js-hero-img");
    const overlayEl = root.querySelector(".js-hero-overlay");
    const titleEl = root.querySelector(".js-hero-title");
    const subtitleEl = root.querySelector(".js-hero-subtitle");
    const ctaEl = root.querySelector(".js-hero-cta");
    // -------------------------------
    // 1) Imagen (Parcel-friendly)
    // -------------------------------
    const asset = wrap.querySelector(".js-hero-asset");
    const src = asset && asset.getAttribute("src") || wrap.dataset.heroSrc || "";
    const alt = (wrap.dataset.heroAlt || "").trim();
    const title = (wrap.dataset.heroTitle || "").trim();
    const subtitle = (wrap.dataset.heroSubtitle || "").trim();
    if (img && src) {
        img.setAttribute("src", src);
        img.setAttribute("alt", alt || title || "Hero");
    }
    // -------------------------------
    // 2) Título / subtítulo (opcionales)
    // -------------------------------
    if (titleEl) {
        titleEl.textContent = title;
        titleEl.classList.toggle("hidden", title === "");
    }
    if (subtitleEl) {
        subtitleEl.textContent = subtitle;
        subtitleEl.classList.toggle("hidden", subtitle === "");
    }
    // -------------------------------
    // 3) Overlay (opcional)
    //    - Si pasas data-hero-overlay="bg-black/40" => sustituye clase base
    //    - Si pasas "0.3" o "30" => ajusta opacidad sobre negro
    // -------------------------------
    if (overlayEl) {
        const overlayRaw = (wrap.dataset.heroOverlay || "").trim();
        if (overlayRaw) {
            // Caso Tailwind class: "bg-black/40", "bg-black/50", etc.
            if (overlayRaw.startsWith("bg-")) {
                // Limpia posibles bg-* previas (simple y seguro)
                overlayEl.className = overlayEl.className.split(" ").filter((c)=>!c.startsWith("bg-")).join(" ");
                overlayEl.classList.add(overlayRaw);
            } else {
                // Caso numérico: "0.3" o "30"
                let v = Number(overlayRaw);
                if (!Number.isNaN(v)) {
                    if (v > 1) v = v / 100; // "30" => 0.3
                    v = Math.max(0, Math.min(1, v));
                    overlayEl.style.backgroundColor = `rgba(0,0,0,${v})`;
                }
            }
        }
    }
    // -------------------------------
    // 4) CTA opcional (blindado)
    // -------------------------------
    const ctaLabel = (wrap.dataset.heroCtaLabel || "").trim();
    const ctaLink = (wrap.dataset.heroCtaLink || "").trim();
    const hasCTA = ctaLabel !== "" && ctaLink !== "";
    if (ctaEl) {
        // Reset seguro
        ctaEl.classList.add("hidden");
        ctaEl.setAttribute("aria-hidden", "true");
        ctaEl.textContent = "";
        if (ctaEl.tagName === "A") ctaEl.removeAttribute("href");
        // Activar si procede
        if (hasCTA && ctaEl.tagName === "A") {
            ctaEl.textContent = ctaLabel;
            ctaEl.setAttribute("href", ctaLink);
            ctaEl.classList.remove("hidden");
            ctaEl.removeAttribute("aria-hidden");
        }
    }
    // -----------------------------------
    // Fondo de color a ancho completo (opcional)
    // -----------------------------------
    const bgClass = (wrap.dataset.heroBg || "").trim();
    if (bgClass) root.classList.add(bgClass);
});
// ==================================================================
// Componente split-overflow.html (hidratación + layout + altura imagen)
// ==================================================================
document.querySelectorAll("[data-split-overflow]").forEach((wrap)=>{
    const root = wrap.querySelector(".js-split-overflow-root");
    if (!root) return;
    const grid = root.querySelector(".js-split-overflow-grid");
    const imageCol = root.querySelector(".js-split-overflow-image");
    const textCol = root.querySelector(".js-split-overflow-text");
    const figure = root.querySelector(".js-split-overflow-figure");
    const img = root.querySelector(".js-split-overflow-img");
    const titleEl = root.querySelector(".js-split-overflow-title");
    const parasEl = root.querySelector(".js-split-overflow-paras");
    const asset = wrap.querySelector(".js-split-overflow-asset");
    // Parámetros (X lateral, Y vertical)
    const overlapX = parseInt(wrap.dataset.splitOverlapX || "150", 10);
    const overlapY = parseInt(wrap.dataset.splitOverlapY || "50", 10);
    // Exponer X a CSS
    root.style.setProperty("--split-overlap-x", `${overlapX}px`);
    // Layout (image-left / image-right)
    const layout = (wrap.dataset.splitLayout || "image-right").trim();
    root.classList.toggle("is-image-left", layout === "image-left");
    root.classList.toggle("is-image-right", layout !== "image-left");
    if (grid) grid.classList.add("grid", "gap-6", "lg:grid-cols-2", "items-center");
    if (imageCol && textCol) {
        imageCol.classList.remove("lg:order-1", "lg:order-2");
        textCol.classList.remove("lg:order-1", "lg:order-2");
        if (layout === "image-left") {
            imageCol.classList.add("lg:order-1");
            textCol.classList.add("lg:order-2");
        } else {
            textCol.classList.add("lg:order-1");
            imageCol.classList.add("lg:order-2");
        }
    }
    // Imagen (Parcel-friendly)
    const src = asset ? asset.getAttribute("src") : "";
    const alt = wrap.dataset.splitAlt || "";
    if (img && src) {
        img.setAttribute("src", src);
        img.setAttribute("alt", alt);
    }
    // Exponer la imagen a CSS (para versión móvil “editorial”)
    if (src) root.style.setProperty("--split-overflow-img", `url("${src}")`);
    // Título
    const title = wrap.dataset.splitTitle || "";
    if (titleEl) titleEl.textContent = title;
    // Párrafos (separados por |) + salto visual
    const parasRaw = wrap.dataset.splitParas || "";
    if (parasEl) {
        parasEl.innerHTML = "";
        if (parasRaw.trim()) {
            const parts = parasRaw.split("|").map((t)=>t.trim()).filter(Boolean);
            parts.forEach((text, index)=>{
                const p = document.createElement("p");
                p.className = "text-lg leading-relaxed";
                if (index < parts.length - 1) p.classList.add("mb-4");
                p.innerHTML = text;
                parasEl.appendChild(p);
            });
        }
    }
    // Altura imagen = altura texto + overlapY (vertical)
    const card = textCol ? textCol.querySelector(":scope > div") : null;
    const applyHeight = ()=>{
        if (!figure || !card) return;
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
        if (!isDesktop) {
            figure.style.height = "";
            figure.style.marginTop = "";
            figure.style.marginBottom = "";
            return;
        }
        const textH = card.getBoundingClientRect().height;
        figure.style.height = `${Math.ceil(textH + overlapY)}px`;
        const half = Math.round(overlapY / 2);
        figure.style.marginTop = `-${half}px`;
        figure.style.marginBottom = `-${half}px`;
    };
    applyHeight();
    if (card && "ResizeObserver" in window) {
        const ro = new ResizeObserver(()=>applyHeight());
        ro.observe(card);
    }
    window.addEventListener("resize", applyHeight, {
        passive: true
    });
});


//# sourceMappingURL=aviso-legal.a25c50d2.js.map
